import ActionsListIcon from '@/common/assets/icons/actionsList.svg?react';
import ArrowLeft from '@/common/assets/icons/arrowRightIcon.svg?react';
import LoadingButton from '@/common/components/base/button/loadingButton';
import RadioGroup from '@/common/components/base/input/radioGroup/RadioGroup';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import MainLayout from '@/common/components/layouts/MainLayout';
import useModal from '@/common/hooks/useModal';
import LoadingPage from '@/common/pages/LoadingPage';
import AddDescriptionModal from '@/modules/FileDetail/components/action/actionList/modals/AddDescriptionModal/AddDescriptionModal';
import SignatureModal from '@/modules/FileDetail/components/action/actionList/modals/SignatureModal/SignatureModal';
import { useActionsSubmit } from '@/modules/FileDetail/hooks/useActionsSubmit';
import { ActionListQuery } from '@/modules/FileDetail/queries/actionList/actionListQuery.type';
import { actionListQueryOptions } from '@/modules/FileDetail/queries/actionList/actionListQueryOptions';
import { ActionsFormDataType } from '@/modules/FileDetail/types/actionsFormData';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import {
  FormProvider,
  useForm,
  useFormContext,
  useWatch,
} from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Center, Flex } from 'styled-system/jsx';
import { token } from 'styled-system/tokens';

export default () => {
  const methods = useForm<ActionsFormDataType>({
    defaultValues: { description: '' },
  });
  return (
    <MainLayout title="اقدامات" header="titleHeader">
      <FormProvider {...methods}>
        <Actions />
      </FormProvider>
    </MainLayout>
  );
};

const Actions = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { handleSubmit, control, resetField } =
    useFormContext<ActionsFormDataType>();
  const { action } = useWatch({ control });

  const {
    data: actionList,
    isError,
    isPending,
    isSuccess,
  } = useQuery(actionListQueryOptions(id!));

  const { open, openModal, closeModal } = useModal();
  const {
    open: signatureOpen,
    closeModal: closeModalSignature,
    openModal: openSignatureModal,
  } = useModal();
  const { onSubmit, isLoading } = useActionsSubmit(id!, openSignatureModal);

  useEffect(() => {
    if (!actionList?.length && isSuccess) {
      navigate(-1);
    }
  }, [actionList]);

  if (isError) {
    return <></>;
  }

  if (isPending) {
    return <LoadingPage />;
  }

  return (
    <Box pt="20px">
      <TitleDescription>لیست اقدامات</TitleDescription>
      <Center my="30px">
        <ActionsListIcon />
      </Center>
      <Typography textStyle="b2">
        اقدام مورد نظر خود را انتخاب کنید :
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box
          px="16px"
          mt="8px"
          borderRadius="8px"
          shadow="cardShadow"
          background="white"
        >
          <RadioGroup
            onChange={() => {
              resetField('description');
              openModal();
            }}
            renderRadioButton={(Component, value: keyof ActionListQuery) => (
              <Flex
                justifyContent="space-between"
                alignItems="center"
                textWrap={'nowrap'}
                py={10}
                borderBottom={{
                  base: '1px solid {colors.gray-2}',
                  _last: 'none',
                }}
              >
                {Component}
                {value === action ? (
                  <Flex
                    alignItems="center"
                    gap="4px"
                    onClick={() => openModal()}
                  >
                    <Typography textStyle="b4" color="purple-2">
                      توضیحات
                    </Typography>
                    <ArrowLeft stroke={token('colors.purple-2')} width={12} />
                  </Flex>
                ) : null}
              </Flex>
            )}
            className={css({
              gap: '10px',
              display: 'flex',
              flexDirection: 'column',
            })}
            name="action"
            options={actionList}
          />
        </Box>
        <FixToBottom>
          <LoadingButton loading={isLoading} disabled={!action} fullWidth>
            ثبت
          </LoadingButton>
        </FixToBottom>
      </form>
      <AddDescriptionModal open={open} closeModal={closeModal} />
      <SignatureModal open={signatureOpen} closeModal={closeModalSignature} />
    </Box>
  );
};
